module.exports = __webpack_public_path__ + "static/media/Eclectic Gallery Wall DIY Tutorial_0017.73717f90.jpg";